class ShippingChoicesComponent extends HTMLElement {
  #abortController = null;
  #activeFetch = null;

  connectedCallback() {
    console.log("ShippingChoicesComponent connected!");
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    // Ascultăm evenimentul de selecție punct FANbox (emis de widget)
    window.addEventListener('map:select-point', this.#handleFanboxSelect.bind(this), { signal });

    // Adăugăm ascultători pentru butoanele de livrare din interiorul componentei
    const addressButton = this.querySelector('#shipping-address');
    const fanboxButton = this.querySelector('#open-fanbox');

    addressButton?.addEventListener('click', this.#handleAddressClick.bind(this), { signal });
    fanboxButton?.addEventListener('click', this.#handleFanboxClick.bind(this), { signal });

    // Inițializăm starea corectă a butonului de checkout la încărcare/morph
    this.#updateCheckoutButtonState();
  }

  disconnectedCallback() {
    console.log("ShippingChoicesComponent disconnected!");
    this.#abortController?.abort();
  }

  #loadMapLibrary() {
    if (window.LoadMapFanBox) return Promise.resolve();

    const existingScript = document.querySelector('script[src*="map-fanbox-points"]');
    if (existingScript) {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (window.LoadMapFanBox) {
            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = "https://unpkg.com/map-fanbox-points@latest/umd/map-fanbox-points.js";
      script.crossOrigin = "anonymous";
      script.async = true;
      script.onload = () => {
        console.log("MapFanBox library loaded successfully.");
        resolve();
      };
      script.onerror = () => {
        reject(new Error("Failed to load MapFanBox library."));
      };
      document.head.appendChild(script);
    });
  }

  #handleAddressClick() {
    console.log('Address delivery selected');
    this.querySelector('#shipping-address')?.classList.add('active');
    this.querySelector('#open-fanbox')?.classList.remove('active');

    // Actualizăm inputurile ascunse globale din cart-products.liquid
    const fanboxId = document.getElementById('fanbox-id');
    const fanboxName = document.getElementById('fanbox-name');
    const fanboxAddress = document.getElementById('fanbox-address');
    const deliveryMethod = document.getElementById('delivery-method');

    if (fanboxId) fanboxId.value = '';
    if (fanboxName) fanboxName.value = '';
    if (fanboxAddress) fanboxAddress.value = '';
    if (deliveryMethod) deliveryMethod.value = 'Address';

    // Curățăm afișajul grafic din coș
    const selectedFanboxDiv = this.querySelector('#selected-fanbox');
    if (selectedFanboxDiv) selectedFanboxDiv.innerHTML = '';

    const openFanboxBtn = this.querySelector('#open-fanbox');
    if (openFanboxBtn) {
      const cartTotal = parseFloat(openFanboxBtn.dataset.cartTotal || '0');
      const freeShipping = cartTotal >= 300;
      openFanboxBtn.innerHTML = 'Ridicare din FANbox - ' + (freeShipping ? 'Gratuit' : '24 lei');
    }

    // Salvăm atributele pe server prin AJAX
    this.#saveCartAttributes({
      'Delivery Method': 'Address',
      'FANbox ID': '',
      'FANbox Name': '',
      'FANbox Address': ''
    });
  }

  async #handleFanboxClick() {
    console.log('FANbox button clicked, loading map...');
    try {
      await this.#loadMapLibrary();
      
      if (typeof window.LoadMapFanBox !== 'function') {
        alert('Harta FANbox nu a putut fi inițializată. Încearcă din nou.');
        return;
      }

      window.LoadMapFanBox({
        pickUpPoint: null,
        county: '',
        locality: '',
        rootNode: this.querySelector('#fanbox-root')
      });
    } catch (error) {
      console.error(error);
      alert('Eroare la încărcarea hărții FANbox.');
    }
  }

  #handleFanboxSelect(event) {
    console.log('FANbox point selected:', event.detail);
    const point = event.detail.item;
    if (!point) return;

    // Actualizăm inputurile ascunse globale din cart-products.liquid
    const fanboxIdInput = document.getElementById('fanbox-id');
    const fanboxNameInput = document.getElementById('fanbox-name');
    const fanboxAddressInput = document.getElementById('fanbox-address');
    const deliveryMethodInput = document.getElementById('delivery-method');

    if (fanboxIdInput) fanboxIdInput.value = point.id;
    if (fanboxNameInput) fanboxNameInput.value = point.name;
    if (fanboxAddressInput) fanboxAddressInput.value = point.address;
    if (deliveryMethodInput) deliveryMethodInput.value = 'FANbox';

    // Actualizăm interfața grafică din coș
    const selectedFanboxDiv = this.querySelector('#selected-fanbox');
    if (selectedFanboxDiv) {
      selectedFanboxDiv.innerHTML = '<strong>FANbox selectat:</strong><br>' + point.name;
    }

    const openFanboxBtn = this.querySelector('#open-fanbox');
    if (openFanboxBtn) {
      openFanboxBtn.innerHTML = point.name.substring(0, 20) + '...';
      openFanboxBtn.classList.add('active');
    }

    const addressBtn = this.querySelector('#shipping-address');
    if (addressBtn) {
      addressBtn.classList.remove('active');
    }

    // Salvăm atributele pe server prin AJAX
    this.#saveCartAttributes({
      'Delivery Method': 'FANbox',
      'FANbox ID': point.id,
      'FANbox Name': point.name,
      'FANbox Address': point.address
    });
  }

  #saveCartAttributes(attributes) {
    if (this.#activeFetch) {
      this.#activeFetch.abort();
    }

    const checkoutButton = this.#getCheckoutButton();
    if (checkoutButton) checkoutButton.disabled = true;

    const abortController = new AbortController();
    this.#activeFetch = abortController;

    const route = (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) 
      || '/cart/update.js';

    fetch(route, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes }),
      signal: abortController.signal
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart attributes saved:', cart);
      this.#activeFetch = null;
      this.#updateCheckoutButtonState();
    })
    .catch(error => {
      if (error.name !== 'AbortError') {
        console.error('Error saving attributes:', error);
        this.#activeFetch = null;
        this.#updateCheckoutButtonState();
      }
    });
  }

  #getCheckoutButton() {
    return this.closest('.cart-summary')?.querySelector('[name="checkout"]') 
      || this.closest('.cart-drawer__content')?.querySelector('[name="checkout"]')
      || this.closest('.cart-totals')?.querySelector('[name="checkout"]')
      || document.querySelector('[name="checkout"]');
  }

  #updateCheckoutButtonState() {
    const checkoutButton = this.#getCheckoutButton();
    if (!checkoutButton) return;

    // Verificăm dacă există selecție validă
    const fanboxIdInput = document.getElementById('fanbox-id');
    const hasFanboxLocker = fanboxIdInput && fanboxIdInput.value.trim() !== '';

    const addressBtn = this.querySelector('#shipping-address');
    const fanboxBtn = this.querySelector('#open-fanbox');

    const isAddressActive = addressBtn && addressBtn.classList.contains('active');
    const isFanboxActive = fanboxBtn && fanboxBtn.classList.contains('active');

    const isDeliverySelected = isAddressActive || (isFanboxActive && hasFanboxLocker);

    if (isDeliverySelected) {
      checkoutButton.disabled = false;
      
      // Verificăm suplimentar dacă avem produse în coș
      const cartCountText = document.querySelector('[ref="cartBubbleCount"]')?.textContent || '0';
      if (parseInt(cartCountText, 10) === 0) {
        checkoutButton.disabled = true;
      }
    } else {
      checkoutButton.disabled = true;
    }
  }
}

if (!customElements.get('shipping-choices-component')) {
  customElements.define('shipping-choices-component', ShippingChoicesComponent);
}
